import React from 'react'
import SvgIcon from 'components/SvgIcon'

const IconLeftArrow = props => (
  <SvgIcon
    x="0px"
    y="0px"
    viewBox="0 0 22 39"
    // fill="#00a6d3"
    {...props}>
    <g transform="translate(35.318 48.011) rotate(180)">
      <path
        fill="currentColor"
        d="M14.259,47.26a2.572,2.572,0,0,0,3.635,0L34.567,30.587a2.594,2.594,0,0,0,0-3.65L17.894,10.263A2.57,2.57,0,0,0,14.259,13.9L29.123,28.761,14.259,43.625A2.572,2.572,0,0,0,14.259,47.26Z"></path>
    </g>
  </SvgIcon>
)

export default IconLeftArrow
